import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Non-deleted Profit Distributions with their cutoffs (newest first)
export const getProfitDistributions = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/profit_distribution/getProfitDistributions`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
